import type { RootState } from '@generalTypes/rootStateTypes';
import type { StudyProgramme } from '@generalTypes/samTypes';
import { KovResourcePicker } from '@kathondvla/react-shared-components/src/components';
import type { EditAsideStudyProgrammes } from '@nodeTypeConfig/configTypes';
import { patchNodeAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { escapeRegExp, set } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import {
  selectStudyProgrammeOptions,
  selectStudyProgrammesSelectedOptions,
} from './asideStudyProgrammeSelectors';

const filterData = ({ data }, str) => {
  if (!str || str.trim().length === 0) {
    return true;
  }
  const regExp = new RegExp(escapeRegExp(str), 'gi');
  return regExp.test(data.title);
};

const AsideStudyProgrammes: React.FC<{
  config: EditAsideStudyProgrammes;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const editHref = useEditHref();

  const dispatch = useDispatch();

  const onChange = (item: StudyProgramme[]) => {
    const patch = set(
      {},
      config.property,
      item.map((z) => ({ href: z.$$meta.permalink })),
    );
    dispatch(patchNodeAction(getResourceKey(editHref), patch));
  };

  const studyProgrammeOptions = useSelector((state: RootState) =>
    selectStudyProgrammeOptions(state),
  );

  const selectedOptions = useTypedSelector((state) =>
    selectStudyProgrammesSelectedOptions(state, editHref, config),
  );

  return (
    <>
      <label className="control-label">{config.label}</label>
      {studyProgrammeOptions.length === 0 ? (
        <div className="form-group shimmer narrowLine" />
      ) : (
        <KovResourcePicker
          value={selectedOptions}
          localData={studyProgrammeOptions}
          clearable={true}
          disabled={readonly}
          onChange={onChange}
          placeholder="Selecteer een studierichting..."
          display="title"
          multiple={true}
          menuPlacement="bottom"
          filter={filterData}
        />
      )}
    </>
  );
};

AsideStudyProgrammes.displayName = 'AsideStudyProgrammes';

export default AsideStudyProgrammes;

AsideStudyProgrammes.propTypes = {
  config: any,
  readonly: any,
};
